import { render, staticRenderFns } from "./addAdress.vue?vue&type=template&id=4de57012&scoped=true&"
import script from "./addAdress.vue?vue&type=script&lang=js&"
export * from "./addAdress.vue?vue&type=script&lang=js&"
import style0 from "./addAdress.vue?vue&type=style&index=0&id=4de57012&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de57012",
  null
  
)

export default component.exports